import { render, staticRenderFns } from "./BarcodeButton.vue?vue&type=template&id=e960055c&scoped=true&"
import script from "./BarcodeButton.vue?vue&type=script&lang=ts&"
export * from "./BarcodeButton.vue?vue&type=script&lang=ts&"
import style0 from "./BarcodeButton.vue?vue&type=style&index=0&id=e960055c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e960055c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
